import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'catalogos/tiempo-de-contratacion';

/**
 * GET Tiempos De Contrataciones
 * @returns {Promise<object[]>}
 */
export const getTiemposDeContrataciones = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Tiempos de Contrataciòn
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getTiempoDeContratacion = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Tiempos de Contrataciòn
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postTiempoDeContratacion = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Tiempos de Contrataciòn
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchTiempoDeContratacion = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Tiempos de Contrataciòn
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteTiempoDeContratacion = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
